<template>
  <a-form :model="form">
    <a-form-item>
      <!--<a-ext-check-target-picker-county region="320100" v-model="form.val"></a-ext-check-target-picker-county>-->
      <!--<a-ext-panel-check-box label="就不高速你" v-model="form.val"></a-ext-panel-check-box>-->
      <!--<a-ext-bad-std-select v-model="form.val"></a-ext-bad-std-select>-->
      <!--<a-ext-check-target-picker-county region="320100" :total.sync="form.total" v-model="form.val"></a-ext-check-target-picker-county>-->
      <!--<a-ext-check-target-picker-city region="320100" :total.sync="form.total" v-model="form.val"></a-ext-check-target-picker-city>-->
      <h1>12222222</h1>
      <!--<a-ext-monit-link-check-box v-model="form.val"></a-ext-monit-link-check-box>-->
      <!--<a-ext-check-target-picker-city-show region="320100" :total.sync="form.total" v-model="form.val"></a-ext-check-target-picker-city-show>-->
      <!--<a-ext-check-target-picker-county-show region="320100" :total="form.total" v-model="form.val"></a-ext-check-target-picker-county-show>-->
      <a-ext-pin-zhong-and-bad-select v-model="form.val"></a-ext-pin-zhong-and-bad-select>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" @click="test">查询</a-button>
    </a-form-item>
  </a-form>
</template>

<script>
// import AExtCheckTargetPickerCity from '../../components/AntDesignExt/AExtCheckTargetPicker/AExtCheckTargetPickerCity'
// import AExtCheckTargetPickerCityShow from '../../components/AntDesignExt/AExtCheckTargetPicker/AExtCheckTargetPickerCityShow'
// import AExtPanelCheckBox from '../../components/AntDesignExt/AExtPanelCheckBox/index'
import AExtBadStdSelect from '../../components/AntDesignExt/AExtSelect/AExtBadStdSelect'
import AExtMonitLinkCheckBox from '../../components/AntDesignExt/AExtPanelCheckBox/AExtMonitLinkCheckBox'
import AExtPinZhongAndBadSelect from '../../components/AntDesignExt/AExtPinZhongAndBadSelect/AExtPinZhongAndBadSelect'
export default {
    name: "TestAExt",
    components:{AExtBadStdSelect,AExtMonitLinkCheckBox,AExtPinZhongAndBadSelect},
    data(){
        return{
            form:{
                val:null,
                total:0
            }
        }
    },
    methods:{
        test()
        {
            // alert(JSON.stringify(this.form));
        }
    }
}
</script>

<style scoped>

</style>